import { render, staticRenderFns } from "./PassengerPage.vue?vue&type=template&id=51a5ee66"
import script from "./PassengerPage.vue?vue&type=script&lang=ts"
export * from "./PassengerPage.vue?vue&type=script&lang=ts"
import style0 from "./PassengerPage.vue?vue&type=style&index=0&id=51a5ee66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports